// Runtime deployment config helpers

export function getApiBase(): string {
  // In production, the UI is served by the same server that hosts the API
  // In dev mode (npm run dev), we might want to point to a different backend
  return import.meta.env.VITE_API_BASE || ''
}

export function getLogoutRedirectUrl(): string {
  // Override with VITE_LOGOUT_REDIRECT_URL if needed
  // Default: go back to /ui/login after logout
  return import.meta.env.VITE_LOGOUT_REDIRECT_URL || '/ui/login'
}
